<template>
    <teleport to="body">
        <div v-if="isOpen && src" class="image-viewer-overlay" @click="close">
            <img :src="src" @click.stop />
            <button class="close-btn" @click="close">×</button>
        </div>
    </teleport>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from 'vue';

const props = defineProps({
    src: {
        type: String,
        default: null
    },
    modelValue: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(props.modelValue);

watch(() => props.modelValue, (val) => {
    isOpen.value = val;
});

const close = () => {
    isOpen.value = false;
    emit('update:modelValue', false);
};
</script>

<style lang="scss">
.image-viewer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    cursor: zoom-out;

    img {
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
        cursor: default;
    }

    .close-btn {
        position: absolute;
        top: 20px;
        right: 20px;
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        cursor: pointer;
    }
}
</style>
